import { useMemo } from "react";

import { AttentionBadge } from "@layout/SidebarLeft";
import { useLocation, useNavigate } from "react-router";

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@components/DropdownMenu";
import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { useVrVideoHistoryQuery } from "@storage/queries/gallery";
import { usePostListQuery } from "@storage/queries/post";

import { cn } from "@lib/utils";

import { isMobile } from "@utils/deviceDetect";

import { ICON_PATHS } from "@configs/icons";
import { ROUTES } from "@configs/routes";

export const LogoMobile = () => {
	const navigate = useNavigate();

	const location = useLocation();
	const postListQuery = usePostListQuery();
	const vrVideoHistoryQuery = useVrVideoHistoryQuery(null);

	const menu = useMemo(
		() => [
			{
				label: (
					<Stack direction="row" align="center" spacing={8}>
						<Image width={24} height={24} src={ICON_PATHS.CHAT} alt="chat" />
						<Typography size="sm" padding="none">
							Chat
						</Typography>
					</Stack>
				),
				key: ROUTES.HOME,
			},
			{
				label: (
					<Stack direction="row" align="center" spacing={8}>
						<Image width={24} height={24} src={ICON_PATHS.CONFIG} alt="showsettings" />
						<Typography size="sm" padding="none">
							Settings
						</Typography>
					</Stack>
				),
				key: ROUTES.SHOW_SETTINGS,
			},
			{
				label: (
					<Stack direction="row" align="center" spacing={8}>
						<div id="posts_wrap" className="posts_wrap relative">
							<Image width={24} height={24} src={ICON_PATHS.POSTS} alt="postIcon" />
							{postListQuery.isSuccess && postListQuery.data.posts.length === 0 ? (
								<AttentionBadge className="size-2.25" />
							) : null}
						</div>
						<Typography size="sm" padding="none">
							Posts
						</Typography>
					</Stack>
				),
				key: ROUTES.POSTS,
			},
			{
				label: (
					<Stack direction="row" align="center" spacing={8}>
						<div id="videos_wrap" className="videos_wrap relative">
							<Image width={24} height={24} src={ICON_PATHS.VE_VIDEOS} alt="vr_videos" />
							{vrVideoHistoryQuery.isSuccess && vrVideoHistoryQuery.data.pagination.total_items_count === 0 ? (
								<AttentionBadge className="size-2.25" />
							) : null}
						</div>
						<Typography size="sm" padding="none">
							Videos
						</Typography>
					</Stack>
				),
				key: ROUTES.VR_VIDEO,
			},
			{
				label: (
					<Stack direction="row" align="center" spacing={8}>
						<Image width={24} height={24} src={ICON_PATHS.BLOCKED} alt="blacklists" />
						<Typography size="sm" padding="none">
							Blacklist
						</Typography>
					</Stack>
				),
				key: ROUTES.BLACKLIST,
			},
		],
		[postListQuery.isSuccess, vrVideoHistoryQuery.isSuccess],
	);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger className="mr-2 border-none outline-none" openOnHover={!isMobile()}>
				<Stack
					align="center"
					justify="center"
					className="h-10 w-10 cursor-pointer rounded-lg bg-block px-1.5 py-0.5 hover:bg-grey-line"
				>
					<Image width={28} height={16} src={ICON_PATHS.LOGO_MINI} alt="logo" />
					<Image width={22} height={12} src={ICON_PATHS.POINTS} alt="points" />
				</Stack>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="mt-1 w-37 py-1">
				{menu.map((item) => (
					<DropdownMenuItem
						onClick={() => navigate(item.key)}
						className={cn(location.pathname === item.key ? "bg-primary hover:bg-primary" : "")}
						key={item.key}
					>
						{item.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
